
const commonColors = {
    // Brand colors (same in both modes)
    orange: "#ff7f40",
    green: "#38A169",
    green_hover: "#2F855A",
    red: "#E53E3E",
    red_button: "#C53030",
    red_hover: "#9C2C2C",
    yellow: "#e6f57b",
    light_green: "#bddfc5",
};

export const lightTheme = {
    ...commonColors,
    dark_green: "#1a3c34",
    dark_green_hover: "#28543d",
    accent_green: "#1a3c34",
    accent_green_hover: "#28543d",

    // Backgrounds
    bg_primary: "#ffffff",
    bg_secondary: "#f5f6fa",
    bg_tertiary: "#F7FAFC",
    bg_hover: "#f1f5f9",
    bg_muted: "#EDF2F7",
    bg_sidebar: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
    logo_filter: "none",

    // Text
    text_primary: "#1a202c",
    text_secondary: "#64748b",
    text_muted: "#718096",

    // Borders & Shadows
    border_default: "#E2E8F0",
    border_focus: "#CBD5E0",
    shadow_default: "rgba(0, 0, 0, 0.08)",
    shadow_hover: "rgba(74, 144, 226, 0.15)",

    // Interactive
    accent_bg: "rgba(74, 144, 226, 0.1)",
    accent_bg_hover: "rgba(74, 144, 226, 0.15)",
    accent_bg_subtle: "rgba(74, 144, 226, 0.05)",
    accent_bg_active: "rgba(74, 144, 226, 0.2)",
    highlight_bg: "rgba(26, 60, 52, 0.05)",
    icon_bg: "rgba(112, 212, 75, 0.1)",


    // Status backgrounds
    bg_error: "#fef2f2",
    bg_error_hover: "#fee2e2",
    bg_warning: "#fef3c7",
    bg_success: "#dcfce7",
    bg_info: "#eff6ff",
    border_error: "#fca5a5",
    border_warning: "#fde68a",
    border_success: "#bbf7d0",
    text_on_brand: "#ffffff",

    // Legacy aliases (backward compat)
    dark_blue: "#2D3748",
    dark_blue_hover: "#4A5568",
    card_white: "#FFFFFF",
    card_white_hover: "#F7FAFC",
    input_border: "#E2E8F0",
    input_outline: "#CBD5E0",
    white_divider: "#E2E8F0",
    menu_inactive: "#718096",
    white_background: "#FFFFFF",
    soon_background: "#EDF2F7",
    gray_hover: "#718096",
    light_gray: "#F7FAFC",
    dark_gray: "#4A5568",
    desc_color: "#718096",
};

export const darkTheme: ThemeType = {
    ...commonColors,
    dark_green: "#e2e8f0",
    dark_green_hover: "#f1f5f9",
    accent_green: "#059669",
    accent_green_hover: "#047857",

    // Backgrounds
    bg_primary: "#1a1b23",
    bg_secondary: "#12131a",
    bg_tertiary: "#22232d",
    bg_hover: "#2a2b37",
    bg_muted: "#22232d",
    bg_sidebar: "linear-gradient(180deg, #1e1f2b 0%, #16171f 100%)",
    logo_filter: "brightness(0) invert(1)",

    // Text
    text_primary: "#e2e8f0",
    text_secondary: "#94a3b8",
    text_muted: "#64748b",

    // Borders & Shadows
    border_default: "#2d2e3a",
    border_focus: "#3d3e4a",
    shadow_default: "rgba(0, 0, 0, 0.3)",
    shadow_hover: "rgba(74, 144, 226, 0.2)",

    // Interactive
    accent_bg: "rgba(74, 144, 226, 0.15)",
    accent_bg_hover: "rgba(74, 144, 226, 0.25)",
    accent_bg_subtle: "rgba(74, 144, 226, 0.08)",
    accent_bg_active: "rgba(74, 144, 226, 0.3)",
    highlight_bg: "rgba(26, 60, 52, 0.15)",
    icon_bg: "rgba(95, 184, 61, 0.15)",


    // Status backgrounds
    bg_error: "#3b1a1a",
    bg_error_hover: "#4a2020",
    bg_warning: "#3b3010",
    bg_success: "#1a3320",
    bg_info: "#1a2540",
    border_error: "#7f1d1d",
    border_warning: "#92400e",
    border_success: "#166534",
    text_on_brand: "#ffffff",

    // Legacy aliases (dark variants)
    dark_blue: "#e2e8f0",
    dark_blue_hover: "#cbd5e1",
    card_white: "#1a1b23",
    card_white_hover: "#22232d",
    input_border: "#2d2e3a",
    input_outline: "#3d3e4a",
    white_divider: "#2d2e3a",
    menu_inactive: "#94a3b8",
    white_background: "#1a1b23",
    soon_background: "#22232d",
    gray_hover: "#94a3b8",
    light_gray: "#22232d",
    dark_gray: "#cbd5e1",
    desc_color: "#94a3b8",
};

export type ThemeType = typeof lightTheme;

const Theme = lightTheme;
export default Theme;
